//
//
//
//

import ArticleSlugWrapper from '~/components/Articles/ArticleSlugWrapper.vue';
import { BLOG_TOPICS } from '~/constants/blogConstants';
export default {
    name: 'ToeflArticlePage',
    components: { ArticleSlugWrapper },
    provide() {
        return {
            blogTopic: BLOG_TOPICS.TOEFL
        };
    }
};
